import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'outcomesIndividualComments',
    label: 'Comments',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
